import { getCalendarioFinanzasMensual, getCalendarioFinanzasMensualProduccion } from '../../API/Global/CalendarioFinanzas/CalendarioFinanzasRequest';
export const obtenerTasaCambioFinanzas = async (fecha) => {
    let d = new Date(fecha)
    let mes = (d?.getMonth() + 1) > 1 ? (d?.getMonth() + 1) : 1
    let anio = d?.getFullYear()
    let tasaCambio = 0

    const tempoCalendario = await getCalendarioFinanzasMensualProduccion()
    if (tempoCalendario?.length > 0) {
        let tempoTasaMes = tempoCalendario.find((t) => t.NoMes === mes && t.Anio === anio)

        if (tempoTasaMes) {
            if (tempoTasaMes?.TasaCambio > 0) {
                tasaCambio = tempoTasaMes?.TasaCambio
            }
        }
    }

    return tasaCambio


}

export const RedondearNumero = (value, digitos = 2) => {
    if (value) {
        let factor = Math.pow(10, digitos);
        let num = Math.round(value * factor) / factor;
    
        return Number(num?.toFixed(digitos));

    }else{
        return 0
    }
}